import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=454ad20d&scoped=true&"
import script from "./NewsList.vue?vue&type=script&lang=js&"
export * from "./NewsList.vue?vue&type=script&lang=js&"
import style0 from "./NewsList.vue?vue&type=style&index=0&id=454ad20d&scoped=true&lang=scss&"
import style1 from "./NewsList.vue?vue&type=style&index=1&id=454ad20d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454ad20d",
  null
  
)

export default component.exports